import CHART_TYPES from '../charts'

import Partners from 'modules/crm/enums/partner-enum'

export default {
  reportingAdvancedPaypal: {
    route: '/financial-reports/advanced/paypal',
    charts: [
      {
        title: 'Website Builder',
        type: CHART_TYPES.GRAPH,
        name: 'websiteBuilder'
      },
      {
        title: 'Sitey',
        type: CHART_TYPES.GRAPH,
        name: 'sitey'
      },
      {
        title: 'Site Builder',
        type: CHART_TYPES.GRAPH,
        name: 'siteBuilder'
      },
      {
        title: 'Sitelio',
        type: CHART_TYPES.GRAPH,
        name: 'sitelio'
      },
      {
        title: 'NET PayPal Progress - Websitebuilder',
        type: CHART_TYPES.TABLE,
        name: 'paypalProgressWebsiteBuilder'
      },
      {
        title: 'NET PayPal Progress - Sitey',
        type: CHART_TYPES.TABLE,
        name: 'paypalProgressSitey'
      },
      {
        title: 'NET PayPal Progress - Sitebuilder',
        type: CHART_TYPES.TABLE,
        name: 'paypalProgressSiteBuilder'
      },
      {
        title: 'NET PayPal Progress - Sitelio',
        type: CHART_TYPES.TABLE,
        name: 'paypalProgressSitelio'
      },
      {
        title: 'PayPal Completed - Websitebuilder',
        type: CHART_TYPES.TABLE,
        name: 'paypalCompletedWebsiteBuilder'
      },
      {
        title: 'PayPal Completed - Sitey',
        type: CHART_TYPES.TABLE,
        name: 'paypalCompletedSitey'
      },
      {
        title: 'PayPal Completed - Sitebuilder',
        type: CHART_TYPES.TABLE,
        name: 'paypalCompletedSiteBuilder'
      },
      {
        title: 'PayPal Completed - Sitelio',
        type: CHART_TYPES.TABLE,
        name: 'paypalCompletedSitelio'
      }
    ]
  },
  reportingAdvancedNGS: {
    route: '/financial-reports/advanced/ngs',
    charts: [
      {
        title: 'PayPal NGS Buckets',
        type: CHART_TYPES.GRAPH,
        name: 'paypalNGSBuckets'
      },
      {
        title: 'PayPal NGS',
        type: CHART_TYPES.GRAPH,
        name: 'paypalNGS'
      },
      {
        title: 'Overdue Service NGS',
        type: CHART_TYPES.TABLE,
        name: 'overdueServiceNGS'
      }
    ]
  },
  reportingAdvancedExpress: {
    route: '/financial-reports/advanced/express',
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title: 'The displayed data is direct customers only. These stats are updated every hour.'
      },
      // {
      //   title: 'Express Editor Chunks',
      //   name: 'ChunksExpress',
      //   condensed: true,
      //   type: CHART_TYPES.TABLE,
      //   className: 'grid-col-6',
      //   tooltip:
      //     'The percentage of new customers that gets to see the choice modal for the main brands on a specific date (last date from the date range).'
      // },
      {
        title: 'Sites saved to paid conversion',
        name: 'joinconversionExpress',
        type: CHART_TYPES.TINY,
        suffix: '%',
        tooltip:
          'Conversion of saved Express sites to paid Express sites (EE New hosting units / EE saved sites in % on date). The trend percentage measures the difference in % between start and end date of period.'
      },
      // {
      //   title: 'Express Editor choice selection for new sign ups',
      //   name: 'ChoiceSelectionNewSignupsExpress',
      //   type: CHART_TYPES.FIXED,
      //   tooltip: <div>The customers that this graph is based on, are the customers seeing the Traditional/Express Choice Modal on a specific date.<br />
      //     The graphs shows what percentage saved (on that same day!) a Traditional Site, an Express Site or no site at all.<br />
      //     Please note that stats will only be reliable when chunk percentage hasn't been changed during the day.</div>
      // },
      {
        title: 'Ratio Total Units Sold',
        name: 'ratiounitssoldExpress',
        type: CHART_TYPES.FIXED,
        userFriendlyLabels: true,
        tooltip:
          'The ratio of new hosting units that are linked to a Traditional site, Express site or no site at all on a specific date.',
        className: 'grid-col-8'
      },
      {
        title: 'Sales Results Express',
        name: 'NetResultsExpress',
        type: CHART_TYPES.TABLE,
        tooltip: [
          'EE Paid Conversion and Traditional Paid Conversion shows the conversion from saved sites to paid sites for the Express Editor and for the Traditional Editor.',
          '(New hosting units / saved sites in % on date).',
          "Please note that a saved site doesn't necessarily become a paid site on the same date.",
          'Also note that Traditional Saved Sites is the number of all traditional saved sites, not only the one that have seen the modal.'
        ]
      },
      {
        title: 'New Hosting units by term',
        name: 'newHostingUnitsTermsExpress',
        type: CHART_TYPES.FIXED,
        stack: ['Express', 'Traditional'],
        userFriendlyLabels: true,
        tooltip:
          '2 columns per date are shown (if applicable), left Traditional/right Express, showing the ratio between terms chosen for both Express as Traditional sites.'
      },
      {
        title: 'New hosting units for plans',
        name: 'NewHostingUnitsPlansExpress',
        type: CHART_TYPES.FIXED,
        stack: ['Express', 'Traditional'],
        userFriendlyLabels: true,
        tooltip:
          '2 columns per date are shown (if applicable), left Traditional/right Express, showing the ratio between terms chosen for both Express as Traditional sites.'
      }
    ]
  },
  reportingAdvancedConstantContact: {
    route: '/financial-reports/advanced/ctct',
    charts: [
      {
        title: 'Onboarding, Free to Paid conversion',
        name: 'accountscreated',
        type: CHART_TYPES.TABLE,
        tooltip: [
          'Onboarding shows the flows used to enter the Control Panel. Site-flow, Store-flow and Domain-flow are the new flows.',
          "Accounts Paid are all accounts that became paid in the selected period. This doesn't necessarily mean it's a subset of the accounts created in that same period.",
          'Onboarding flows are registered correctly since May 15, 2019'
        ],
        sorting: { default: { fieldNames: ['Name'], direction: true } },
        className: 'grid-col-12',
        dataFilter: data => {
          return data.filter(row => row.LanderType !== 'app-login' && row.LanderType.toLowerCase() !== 'website')
        }
      },
      {
        title: 'Onboarding Flows Total',
        name: 'OnboardingFlowTotals',
        type: CHART_TYPES.TABLE,
        tooltip: [
          'Onboarding shows the flows used to enter the Control Panel since May 15, 2019. Site-flow, Store-flow and Domain-flow are the new flows.',
          'Accounts Paid are all accounts that became paid since May 15, 2019.',
          "'Also saved site' is the percentage of store-onboarding and domain-onboarding users that also saved a site.",
          "'Also added store' is the percentage of site-onboarding and domain-onboarding users that also created a store.",
          "'Also added domain' is the percentage of site-onboarding and store-onboarding users that also bought a domain."
        ],
        sorting: { default: { fieldNames: ['Name'], direction: true } },
        className: 'grid-col-12',
        customRowFormatter: row => {
          if (row.LanderType === 'site-flow') {
            row.AlsoSite = ''
          }
          if (row.LanderType === 'store-flow') {
            row.AlsoStore = ''
          }
          if (row.LanderType === 'domain-flow') {
            row.AlsoDomain = ''
          }
          if (row.LanderType === 'logo-flow') {
            row.AlsoLogo = ''
          }
        }
      },
      {
        title: 'Join to Publish conversion',
        name: 'JoinsToPublish',
        type: CHART_TYPES.TABLE,
        className: 'grid-col-6',
        tooltip:
          'Displays the number of Joins and the Published sites on a specific date, together with the Join to Publish conversion.'
      }
      // {
      //   title: 'CTCT DIFM Domain Creation/Renewal',
      //   name: 'domainscreatedrenewed',
      //   type: CHART_TYPES.TABLE,
      //   tooltip: 'Number of domains created/renewed by Constant Contact employees',
      //   className: 'grid-col-6'
      // }
    ]
  },
  reportingBlog: {
    route: '/financial-reports/advanced/blog',
    charts: [
      {
        title: 'Total blogs created',
        type: CHART_TYPES.CARD,
        name: 'totalblogs',
        tooltip: 'The total number of blogs created (independent of period selection).'
      },
      {
        title: 'Total blogs published',
        type: CHART_TYPES.CARD,
        name: 'TotalBlogsPublished',
        tooltip: 'The total number of blogs published (independent of period selection).'
      },
      {
        title: 'Total blog posts published',
        type: CHART_TYPES.CARD,
        name: 'TotalBlogPostsPublished',
        tooltip: 'The total number of blog posts published (independent of period selection).'
      },
      {
        title: 'Percentage of published sites with a blog',
        type: CHART_TYPES.CARD,
        name: 'PublishedSitesWithBlogRatio',
        suffix: '%',
        tooltip: 'The percentage of all published Express Editor sites that contain a blog.'
      },
      {
        className: 'grid-col-2'
      },
      {
        title: 'Ratio of Number of blog articles',
        type: CHART_TYPES.PIE,
        name: 'blogpostratio',
        tooltip: 'The distribution of blogs with their number of blog articles (independent of period selection).'
      },
      {
        className: 'grid-col-8'
      },
      {
        title: 'Blogs created in period',
        type: CHART_TYPES.GRAPH,
        name: 'createdblogsperday',
        visible: ['SiteBuilder', 'WebsiteBuilder', 'Sitey', 'Sitelio', 'ConstantContact'],
        tooltip: 'Shows the number of blogs created per brand in the selected period.'
      },
      {
        title: 'Blogs first published in period',
        type: CHART_TYPES.GRAPH,
        name: 'blogsfirstpublished',
        visible: ['SiteBuilder', 'WebsiteBuilder', 'Sitey', 'Sitelio', 'ConstantContact'],
        tooltip: 'Shows the number of blogs published per brand in the selected period.'
      },
      {
        title: 'Sites with published blogposts',
        type: CHART_TYPES.TABLE,
        name: 'siteswithpublishedposts',
        tooltip: 'Shows the details of blogs published per brand in the selected period.',
        sorting: { default: { fieldNames: ['BlogPostFirstPublished'], direction: false } }
      }
    ]
  },
  reportingLogo: {
    route: '/financial-reports/advanced/logomaker',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id],
    charts: [
      {
        title: 'Total logos created',
        type: CHART_TYPES.CARD,
        name: 'totallogos',
        tooltip: "Shows the total number of logo's created"
      },
      {
        title: 'Total accounts with logos',
        type: CHART_TYPES.CARD,
        name: 'totalaccountswithlogo',
        tooltip: "Shows the total number of logo's created"
      },
      {
        className: 'grid-col-6'
      },
      {
        title: "Logo's created per day",
        type: CHART_TYPES.GRAPH,
        name: 'createdLogosPerDay',
        tooltip: "Shows the number of logo's created per day and per brand",
        customFormat: CHART_TYPES.BRAND_SITES,
        visible: ['SiteBuilder', 'WebsiteBuilder', 'Sitey', 'Sitelio', 'ConstantContact']
      },
      {
        title: 'Logos created per brand',
        type: CHART_TYPES.TABLE,
        name: 'logoscreatedperbrand',
        tooltip: 'Shows the logos created within the selected period per brand.'
      }
    ]
  },
  reportingContactSync: {
    route: '/financial-reports/advanced/contact-sync',
    charts: [
      {
        title: 'Users with contact sync enabled',
        type: CHART_TYPES.CARD,
        name: 'AppUsersWithActiveContactSyncTotals',
        tooltip: 'Total number of customers that have enabled syncing their contact list'
      },
      {
        title: 'Users with contact sync enabled',
        type: CHART_TYPES.TABLE,
        name: 'appuserswithactivecontactsync',
        tooltip: 'Details of the customers that have enabled syncing their contact list'
      }
    ]
  },
  reportingTranscript: {
    route: '/financial-reports/advanced/transcripts',
    charts: [
      {
        title: 'Total number of analyzed transcripts',
        type: CHART_TYPES.CARD,
        name: 'totaltranscripts',
        tooltip: 'Shows the total number of analyzed transcript'
      },
      {
        title: 'Total number of analyzed transcript with an account',
        type: CHART_TYPES.CARD,
        name: 'totaltranscriptswithaccount',
        tooltip: 'Shows the total number of analyzed transcript with an account'
      },
      {
        className: 'grid-col-8'
      },
      {
        title: 'Top entities of the transcripts',
        type: CHART_TYPES.STACKED,
        name: 'toptranscriptentities',
        tooltipLabel: 'transcripts'
      },
      {
        title: 'Analyzed transcripts with details',
        type: CHART_TYPES.TABLE,
        name: 'alltranscriptswithdetails',
        tooltip: 'Shows the details of transcripts per specific account in the selected period.'
      }
    ]
  },
  reportingBookings: {
    route: '/financial-reports/advanced/bookings',
    charts: [
      {
        title: 'Total booking modules created',
        type: CHART_TYPES.CARD,
        name: 'TotalBookingsCreated',
        tooltip: 'The total number of booking modules created (independent of period selection).'
      },
      {
        title: 'Total booking modules published',
        type: CHART_TYPES.CARD,
        name: 'TotalBookingsPublished',
        tooltip: 'The total number of booking modules that are attached to a published site (independent of period selection).'
      },
      {
        title: 'Percentage of published booking modules',
        type: CHART_TYPES.CARD,
        name: 'PublishedSitesWithBookingRatio',
        suffix: '%',
        tooltip: 'The percentage of booking modules that are attached to a published site (independent of period selection).'
      },
      {
        className: 'grid-col-6'
      },
      {
        title: 'Ratio of services',
        type: CHART_TYPES.PIE,
        name: 'BookingServicesRatio'
      },
      {
        title: 'Ratio of resources',
        type: CHART_TYPES.PIE,
        name: 'BookingResourcesRatio'
      },
      {
        className: 'grid-col-6'
      },
      {
        title: 'Booking modules created in period',
        type: CHART_TYPES.GRAPH,
        name: 'BookingsCreatedPerDay',
        tooltip: 'Shows the number of booking modules created per brand in the selected period.'
      },
      {
        title: 'Booking modules first published in period',
        type: CHART_TYPES.GRAPH,
        name: 'BookingsPublishedPerDay',
        tooltip: 'Shows the number of sites with booking modules published per brand in the selected period.'
      },
      {
        title: 'Sites with published booking modules',
        type: CHART_TYPES.TABLE,
        name: 'PublishedSitesWithBookings',
        sorting: { default: { fieldNames: ['SiteFirstPublished'], direction: false } }
      },
      {
        title: 'Published sites with appointments',
        type: CHART_TYPES.TABLE,
        name: 'publishedsiteswithappointments'
      }
    ]
  },
  verticals: {
    route: '/financial-reports/advanced/verticals',
    brandSelection: true,
    charts: [
      {
        type: CHART_TYPES.TABLE,
        name: 'accountverticals',
        title: 'Account verticals'
      },
      {
        className: 'grid-col-6',
        type: CHART_TYPES.PIE,
        name: 'createdaccountspervertical',
        title: 'Created accounts per vertical'
      }
    ]
  },
  profServices: {
    route: '/financial-reports/advanced/prof-services',
    brandSelection: true,
    extendedBrandSelection: [Partners.GATOR.id, Partners.CTCTBUILDER.id],
    charts: [
      {
        title: 'Total # Prof/Karv Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicescountall',
        tooltip: 'Shows the all time number of Site Advisor and Website Design Services sold. This includes services that were later refunded.'
      },
      {
        title: 'Total $ Prof/Karv Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicesamountall',
        tooltip: 'Shows the all time revenue (excl. VAT) of Site Advisor and Website Design Services sold. Refunded transactions are subtracted from this total.',
        prefix: '$'
      },
      {
        title: 'Total # SA/Karv Session Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicescountsiteadvisor',
        tooltip: 'Shows the all time number of Site Advisor Services sold. This includes services that were later refunded.'
      },
      {
        title: 'Total $ SA/Karv Session Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicesamountsiteadvisor',
        tooltip: 'Shows the all time revenue (excl. VAT) of Site Advisor Services sold. Refunded transactions are subtracted from this total.',
        prefix: '$'
      },
      {
        title: 'Total # WD/Karv Design Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicescountwebsitedesign',
        tooltip: 'Shows the all time number of Website Design Services sold. This includes services that were later refunded.'
      },
      {
        title: 'Total $ WD/Karv Design Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicesamountwebsitedesign',
        tooltip: 'Shows the all time revenue (excl. VAT) of Website Design Services sold. Refunded transactions are subtracted from this total.',
        prefix: '$'
      },
      {
        title: 'Total # WD/Karv - Silver Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicescountwebsitedesignsilver',
        tooltip: 'Shows the all time number of Design Silver Services sold. This includes services that were later refunded.'
      },
      {
        title: 'Total $ WD/Karv - Silver Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicesamountwebsitedesignsilver',
        tooltip: 'Shows the all time revenue (excl. VAT) of Silver Design Services sold. Refunded transactions are subtracted from this total.'
      },
      {
        title: 'Total # WD/Karv - Gold Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicescountwebsitedesigngold',
        tooltip: 'Shows the all time number of Design Gold Services sold. This includes services that were later refunded.'
      },
      {
        title: 'Total $ WD/Karv - Gold Services',
        type: CHART_TYPES.CARD,
        name: 'professionalservicesamountwebsitedesigngold',
        tooltip: 'Shows the all time revenue (excl. VAT) of Gold Design Services sold. Refunded transactions are subtracted from this total.'
      },
      {
        title: 'Prof/Karv Services purchased per brand',
        type: CHART_TYPES.TABLE,
        name: 'professionalservicesperbrand',
        tooltip: 'Shows the number of Site Advisor and Website Design Services sold per brand for the selected period. The # of services includes services that were later refunded. The $ Amount of services is the total $ refunded transactions.'
      },
      {
        title: 'Prof/Karv Services Transactions',
        type: CHART_TYPES.TABLE,
        name: 'professionalservicestransactions'
      }
    ]
  }
}
